import { SurveyUtils } from "./survey-utils";
import {
  ANSWERS_SELECTOR,
  ANSWER_BUTTON_ID_PREFIX,
  BACK_BUTTON_SELECTOR,
  FORWARD_BUTTON_SELECTOR,
  NAVIGATION_PANEL_SELECTOR,
  QUESTION_SELECTOR,
  SUBTITLE_SELECTOR,
  SURVEY_BODY_SELECTOR,
  ZIPCODE_CHECK_BUTTON_SELECTOR,
  ZIPCODE_CHECK_INPUT_SELECTOR,
  ZIPCODE_EMAIL_BUTTON_SELECTOR,
  ZIPCODE_EMAIL_INPUT_SELECTOR,
  ZIPCODE_ERROR_LABEL_SELECTOR,
  ZIPCODE_ERROR_NO_PRIVACY_LABEL_SELECTOR,
  ZIPCODE_LEAD_BOX_SELECTOR,
  ZIPCODE_PRIVACY_INPUT_SELECTOR,
  ZIP_CODE_PRIVACY_HTML_SELECTOR,
} from "./survey.constants";

import { __ } from "@wordpress/i18n";

/**
 * @description ottiene l'html del widget di una risposta
 * @params answer domanda da visualizzare nel widget
 * @return {Promise<string>} html
 */
export const fetchAnswerWidget: (
  answer: string,
  selected: boolean
) => Promise<string> = async (
  answer: string,
  selected: boolean = false
): Promise<string> => {
    return /*html*/ `
      <div id=${ANSWER_BUTTON_ID_PREFIX}-${SurveyUtils.sanitizeText(
      answer
    )} class="answer-card ${selected ? "card-selected" : ""}">
        <div class="answer-card-body">
            <span class="uh-h6 text-uppercase text-center clr-gray-5">${answer}</span>
        </div>
      </div>
    `;
  };

/**
 * @description ottiene l'html del body del sondaggio - utilizzare selector in survey.models.ts
 * @return {Promise<string>} html
 */
export const fetchStepBody: () => Promise<string> =
  async (): Promise<string> => {
    return /*html*/ `
    <div id="${SURVEY_BODY_SELECTOR}" class="survey-body">

      <div class="survey-header d-flex align-items-center flex-column mb-4">
        <div class="row mb-4">
          <div class="col-12">
            <span id="${QUESTION_SELECTOR}" class="title uh-h3 clr-secondary"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span id="${SUBTITLE_SELECTOR}" class="uh-body-big clr-secondary"></span>
          </div>
        </div>
      </div>

      <div class="row my-5">
        <div class="col-12 d-flex flex-column my-5 mt-lg-0 align-items-center">
            <div
              id="${ANSWERS_SELECTOR}"
              class="row card-container gy-3"
            ></div>
        </div>
      </div>
      <div class="row justify-content-center position-relative" id="${NAVIGATION_PANEL_SELECTOR}"></div>

       </div>
        `;
  };
export const fetchZipCodeNotAvailable: (
  insertedCap: string) => Promise<string> = async (insertedCap: string): Promise<string> => {
    return /*html*/ `
  <div class="col-12 d-flex justify-content-center">
    <div class="zipcode-check-container">
      <div class="zipcode-check-body">
        <div class="row flex-column">
          <div class="col-12">
            <div class="row flex-column py-3">
                <div class="col-12 d-flex justify-content-center text-center pb-4">
                <img src="${window.php_pars.asset_path
      }/img/icon-hourglass.svg" width="24px" height="45px" alt="Non disponibile" />
                </div>
                <div class="col-12 ps-3 text-center coming-soon-label">
                <strong>
                COMING SOON!
                </strong>
                </div>
            </div>
            <div class="row pb-4">
                <div class="col-12 d-flex justify-content-center text-center coming-soon-message">
                <span class="pb-4 mt-2 divider-bottom">
                Al momento il servizio non è coperto nella tua zona.
                </span>
                </div>
            </div>
            <div id="${ZIPCODE_LEAD_BOX_SELECTOR}" class="d-flex flex-column align-items-center pb-4 g-4 ">
              <div class="row w-100">
                <div class="col-12 d-flex justify-content-center text-center coming-soon-message">
                  <span class="pb-4 mt-2 email-message-text uh-body-small">
                    Lasciaci la tua email e ti avvisiamo non appena il servizio è pronto:
                  </span>
                </div>
              </div>
              <div class="row w-100">
                <div class="d-flex justify-content-center col-12 my-4">
                  <input  placeholder='Inserisci la tua email' id="${ZIPCODE_EMAIL_INPUT_SELECTOR}" class="coming-soon-email-field" />
                </div>
                <div class="d-flex flex-column align-items-start col-12">
                  <label>
                    <input type="checkbox" id="${ZIPCODE_PRIVACY_INPUT_SELECTOR}" class="mt-1 me-1 coming-soon-privacy-input" />
                    <span class="uh-body-small" id="${ZIP_CODE_PRIVACY_HTML_SELECTOR}">
                    </span>
                  </label>
                  <span id="${ZIPCODE_ERROR_NO_PRIVACY_LABEL_SELECTOR}" class="d-none mt-1 uh-body-big zipcode-privacy-error">
                  </span>
                </div>
              </div>
              <div class="row  w-100">
                  <div class="d-flex justify-content-center col-12 mt-4">
                    <button type="button"  id="${ZIPCODE_EMAIL_BUTTON_SELECTOR}" class="button-primary uppercase w-100">
                      <span class="uh-body">${__("Conferma", "unipolhome")}</span>
                      <div class="spinner"></div>
                    </button>
                  </div>
              </div>
              <div class="row">
                  <div class="d-flex justify-content-center col-12 mt-4">
                    <p onclick="history.back()" class="zipcode-back-message text-center">${insertedCap} non è il tuo cap?</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    `;
  }
/**
 * @description box da renderizzare dopo aver raccolto la lead
 * @return {Promise<string>} html
 */
export const fetchLeadTakenBox: () => Promise<string> = async (): Promise<string> => {
  return /*html*/ `
      <div class="row w-100">
      <p class="col-12 uh-body uh-fw-medium text-break text-center">
      ${php_pars.lead_taken_title}
    </p>
    <p class="col-12 uh-body text-center text-break">
    ${php_pars.lead_taken_description}
    </p>
    <p class="col-12 uh-body text-break text-center">
    ${php_pars.lead_taken_description_bottom}
    </p>
      </div>
    `;
};
/**
 * @description ottiene il riquadro con la validazione del cap
 * @param defaultZipCode
 * @return {Promise<string>} html
 */
export const fetchZipCodeCheck: (
  idMestiere: string,
  defaultZipCode?: string
) => Promise<string> = async (idMestiere: string, defaultZipCode?: string): Promise<string> => {
  return /*html*/ `
  <div class="col-12 uh-body-big clr-secondary text-center mt-0 mb-3">
  <div>${__("Non vogliamo farti perdere tempo!", "unipolhome")}</div>
  <div>${__(
    "Inserisci il tuo CAP per scoprire se la nostra rete lavora nella tua area:",
    "unipolhome"
  )}</div>
  </div>
    <div class="col-12 d-flex justify-content-center">
      <div class="zipcode-check-container">
        <form class="zipcode-check-body">
          <div class="row">
            <div class="d-flex justify-content-center col-12">
              <span class="zipcode-title uh-body clr-almost-black text-center">
              ${__(
    "Il CAP da inserire deve coincidere con quello del luogo dell’intervento",
    "unipolhome"
  )}</span>
            </div>
          </div>
          <div class="row">
            <div class="d-flex flex-column col-12 my-4">
              <input data-idmestiere="${idMestiere}"  type="number" id="${ZIPCODE_CHECK_INPUT_SELECTOR}" value='${defaultZipCode ?? ""}' class="zipcode-input" />
              <span id="${ZIPCODE_ERROR_LABEL_SELECTOR}" class="invalid-input-label mt-1 uh-body-big invalid"></span>
            </div>
          </div>
          <div class="row">
              <div class="col-12 mt-4 text-center">
                <button type="submit" id="${ZIPCODE_CHECK_BUTTON_SELECTOR}" class="button-primary uppercase cta-check">
                  <span class="uh-body">${__("Controlla disponibilità", "unipolhome")}</span>
                  <div class="spinner"></div>
                </button>
              </div>
          </div>
        </form>
      </div>
    </div>
  `;
};

export const fetchBottomNavigationPanel: (
  back: boolean,
  forward: boolean
) => Promise<string> = async (
  back: boolean,
  forward: boolean
): Promise<string> => {
    return /*html*/ `
    <div class="col-12 navigation-panel d-flex justify-content-center  py-4 bg-absolute-white ${forward || back ? "sticky" : null
      }">
    <div class="buttons d-flex justify-content-between">
    <div id="${BACK_BUTTON_SELECTOR}" class="button-container ${back ? "" : "invisible "
      }">
        <img  src="${window.php_pars.asset_path
      }/img/icon-arrow-back-survey.svg" alt="back" class="navigation-arrow"/>
      </div>
      <div id="${FORWARD_BUTTON_SELECTOR}" class="button-container ${forward ? "" : "invisible "
      }" ${forward ? 'onclick="history.forward()"' : ""}>
        <img src="${window.php_pars.asset_path
      }/img/icon-arrow-back-survey.svg"  class="navigation-arrow next-arrow"/>
      </div>
     </div>
    </div>

  `;
  };
